// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .p-dialog .p-dialog-header {
    background: #336699;
}

::ng-deep .p-dialog .p-dialog-content {
    background: #336699;
}

::ng-deep .p-dialog .p-dialog-header .p-dialog-title {
    color: #fff;
    font-size: 16px;
}

:host ::ng-deep .p-dialog-header-close-icon {
    color: white;
    font-size: 2rem;
}

.modal-footer {
    border: none;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
    padding-top: 12px;
}

.well {
    border: solid 3px #e9c462;
}

.required:after {
    content: " *";
    color: red;
}

:host ::ng-deep .p-inputnumber-input {
    width: 100% !important;
}

.err-highlight {
    color: red;
    margin: 0;
}

th,
td {
    padding-right: 5px;
}

.modal-body.row > .col-md-3,
.modal-body.row > .col-md-6 {
    padding-left: 20px;
    padding-right: 20px;
}

/* Remove <br> gaps between labels and inputs */
.form-group br {
    display: none;
}

/* Compact form-group spacing and smaller text to match edit-bond dialog */
.form-group {
    margin-bottom: 8px;
}

.form-group label,
.form-group .form-control {
    font-size: 0.875rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/create-bond/create-bond.component.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,+CAA+C;AAC/C;IACI,aAAa;AACjB;;AAEA,0EAA0E;AAC1E;IACI,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;AACvB","sourcesContent":["::ng-deep .p-dialog .p-dialog-header {\r\n    background: #336699;\r\n}\r\n\r\n::ng-deep .p-dialog .p-dialog-content {\r\n    background: #336699;\r\n}\r\n\r\n::ng-deep .p-dialog .p-dialog-header .p-dialog-title {\r\n    color: #fff;\r\n    font-size: 16px;\r\n}\r\n\r\n:host ::ng-deep .p-dialog-header-close-icon {\r\n    color: white;\r\n    font-size: 2rem;\r\n}\r\n\r\n.modal-footer {\r\n    border: none;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    gap: 16px;\r\n    padding-top: 12px;\r\n}\r\n\r\n.well {\r\n    border: solid 3px #e9c462;\r\n}\r\n\r\n.required:after {\r\n    content: \" *\";\r\n    color: red;\r\n}\r\n\r\n:host ::ng-deep .p-inputnumber-input {\r\n    width: 100% !important;\r\n}\r\n\r\n.err-highlight {\r\n    color: red;\r\n    margin: 0;\r\n}\r\n\r\nth,\r\ntd {\r\n    padding-right: 5px;\r\n}\r\n\r\n.modal-body.row > .col-md-3,\r\n.modal-body.row > .col-md-6 {\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n}\r\n\r\n/* Remove <br> gaps between labels and inputs */\r\n.form-group br {\r\n    display: none;\r\n}\r\n\r\n/* Compact form-group spacing and smaller text to match edit-bond dialog */\r\n.form-group {\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.form-group label,\r\n.form-group .form-control {\r\n    font-size: 0.875rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
